export default __webpack_public_path__ + "assets/images/49d636af389b7563fcfb85a502f49c35.png";